import { WiseOwlApi } from '@twiliointernal/e2-commons-shared-api';
import {
  WiseOwlIngress,
  SupportApiResponse,
  WiseOwlGetChatSummaryByIdResponseData,
  WiseOwlChatType,
  ApiResponse,
} from '@twiliointernal/e2-commons-shared-definitions';
import { supportPlansViewTypes } from '@twiliointernal/services-common/containers/SupportPlansView';
import { ValidateChatSessionArgs } from '../definitions';

export const isPaidSupportPlan = (
  currentSupportPlanSid: supportPlansViewTypes.SupportPlanBillableItemSids,
): boolean =>
  currentSupportPlanSid !==
  supportPlansViewTypes.SupportPlanBillableItemSids.developer;

export const validateChatSession = async ({
  sessionId,
  chatId,
  isLoggedIn,
}: ValidateChatSessionArgs): Promise<void> => {
  const ingress = isLoggedIn ? WiseOwlIngress.osc : WiseOwlIngress.oscUngated;
  const wiseOwlApi = new WiseOwlApi(ingress);

  const requestOptions = {
    credentials: 'include',
  } as const;

  let response: ApiResponse<
    WiseOwlChatType | WiseOwlGetChatSummaryByIdResponseData
  >;

  /**
   * User must be logged in for gated chat validation.
   */
  if (isLoggedIn) {
    response = await wiseOwlApi.getChatById({
      ingress: WiseOwlIngress.osc,
      chatId,
      requestOptions,
    });
  } else if (sessionId) {
    /**
     * Session ID is required for ungated chat validation.
     */

    /**
     * We're temporarily using this endpoint to validate ungated chats until
     * we have a dedicated endpoint that can validate both gated and ungated chats.
     */
    response = (await wiseOwlApi.ungatedGetChatSummaryById({
      chatId,
      body: {
        stargateUngatedUserId: sessionId,
      },
      requestOptions,
    })) as SupportApiResponse<WiseOwlGetChatSummaryByIdResponseData>;
  } else {
    /**
     * Throw an error if the user is not logged in and the sessionId is not provided
     * since at least one of them is required for chat validation.
     */

    throw new Error(
      'RSAT Chat validation failed - User must be logged in or sessionId must be present for chat validation',
    );
  }

  const { statusCode, message } = response as SupportApiResponse<
    WiseOwlChatType | WiseOwlGetChatSummaryByIdResponseData
  >;

  if (statusCode !== 200) {
    throw new Error(
      `RSAT Chat validation failed - Validation request failed with status code ${statusCode} - ${message}`,
    );
  }
};
